import type { Permission } from 'src/api/permissionApi'

import { useState } from 'react'
import { useRouter } from 'src/routes/hooks'

import Chip from '@mui/material/Chip'
import Popover from '@mui/material/Popover'
import TableRow from '@mui/material/TableRow'
import Checkbox from '@mui/material/Checkbox'
import MenuItem from '@mui/material/MenuItem'
import TableCell from '@mui/material/TableCell'
import IconButton from '@mui/material/IconButton'

import { Iconify } from 'src/components/iconify'

import { getStatusColor, typeTranslations, statusTranslations } from '../../translations'

type Props = {
  selected: boolean
  permission: Permission
  onSelectRow: (checked: boolean) => void
  onDeleteSuccess?: () => void
}

export default function PermissionTableRow({ selected, permission, onSelectRow, onDeleteSuccess }: Props) {
  const router = useRouter()
  const [open, setOpen] = useState<HTMLElement | null>(null)

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setOpen(null)
  }

  const handleNavigateToDetail = () => {
    router.push(`/dashboard/permissions/${permission.id}`)
    handleCloseMenu()
  }

  const handleDelete = async () => {
    try {
      // Silme işlemi ana bileşende yapılacak
      handleCloseMenu()
      onDeleteSuccess?.()
    } catch (error) {
      console.error('İzin silme hatası:', error)
    }
  }

  return (
    <>
      <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox disableRipple checked={selected} onChange={(event) => onSelectRow(event.target.checked)} />
        </TableCell>

        <TableCell>
          {permission.employee?.firstName} {permission.employee?.lastName}
        </TableCell>
        <TableCell>{typeTranslations[permission.leaveType]}</TableCell>
        <TableCell>{new Date(permission.startDate).toLocaleDateString('tr-TR')}</TableCell>
        <TableCell>{new Date(permission.endDate).toLocaleDateString('tr-TR')}</TableCell>
        <TableCell>{permission.reason}</TableCell>
        <TableCell>
          <Chip
            label={statusTranslations[permission.status]}
            color={getStatusColor(permission.status)}
            size="small"
          />
        </TableCell>
        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        <MenuItem onClick={handleNavigateToDetail}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Düzenle
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Sil
        </MenuItem>
      </Popover>
    </>
  )
}

